import React from "react";
import { PageType } from "../../../enums/page-type.enum";
import PageContent from "../components/PageContent";

const RefundPolicy = () => {
  return <PageContent page={PageType.REFUND_POLICY} title="Refund Policy" />;
};

export default RefundPolicy;
